"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftForm = exports.DraftFormType = void 0;
const react_1 = __importDefault(require("react"));
var DraftFormType;
(function (DraftFormType) {
    DraftFormType["Edit"] = "edit";
    DraftFormType["Create"] = "create";
})(DraftFormType = exports.DraftFormType || (exports.DraftFormType = {}));
class DraftForm extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            title: '',
            content: '',
            saving: false,
        };
    }
    componentDidMount() {
        if (this.props.title && this.props.content) {
            this.setState({
                title: this.props.title,
                content: this.props.content,
            });
        }
    }
    render() {
        return (react_1.default.createElement("div", { className: "draft-form" },
            react_1.default.createElement("input", { className: "draft-form__title", value: this.state.title, autoFocus: true, onChange: (event) => this.setState({ title: event.target.value }), placeholder: "Title" }),
            react_1.default.createElement("textarea", { className: "draft-form__content", value: this.state.content, rows: 15, cols: 80, onChange: (event) => this.setState({ content: event.target.value }), placeholder: "Text" }),
            react_1.default.createElement("div", { className: "draft-form__actions" },
                react_1.default.createElement("button", { className: "button action m", onClick: () => this.onSubmit(), disabled: this.state.saving }, this.getButtonText()))));
    }
    onSubmit() {
        if (!this.state.title || !this.state.content) {
            alert('Title and content are required');
            return;
        }
        this.setState({ saving: true });
        this.props.onSubmit(this.state.title, this.state.content);
    }
    getButtonText() {
        if (this.props.type === DraftFormType.Edit) {
            if (this.state.saving) {
                return 'Saving…';
            }
            else {
                return 'Save';
            }
        }
        else if (this.state.saving) {
            return 'Creating…';
        }
        else {
            return 'Create';
        }
    }
}
exports.DraftForm = DraftForm;
//# sourceMappingURL=DraftForm.js.map